<template>
  <div class="w120 mc mt20">
    <el-row class="w100" :gutter="20">
      <el-col :span="4">
        <div class="w100 bg-w about-nav-bar">
          <el-menu class="w100 of-h" :default-active="activeIndex" @select="goPage">
            <el-submenu index="1">
              <template slot="title">个人中心</template>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeSign" index="officeSign">签名管理</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeSeal" index="officeSeal">印章管理</el-menu-item>
            </el-submenu>
            <el-submenu index="2" v-if="routeJur.OfficeSubject || routeJur.OfficeBiz ||routeJur.OfficeProcess ||  routeJur.OfficeRoleForDepartment || routeJur.OfficeRoleDepartment || routeJur.OfficeRoleCollege">
              <template slot="title">办事大厅</template>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeSubject" index="officeSubject">服务主题</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeBiz" index="officeBiz">服务管理中心</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeBiz" index="officeBizException">服务异常管理</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeProcess" index="OfficeProcess">流程同步管理</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeRoleForDepartment" index="officeRoleForDepartment">角色与部门关系设置</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeRoleDepartment" index="officeRoleDepartment">流程维护人员管理</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeRoleCollege" index="officeRoleCollege">人员所属角色管理</el-menu-item>
            </el-submenu>
            <el-submenu index="3" v-if="routeJur.OfficeServeGroup || routeJur.OfficeRoleForHref">
              <template slot="title">办公区</template>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeServeGroup" index="officeServeGroup">办公区分组配置</el-menu-item>
              <el-menu-item class="ellipsis" v-if="routeJur.OfficeRoleForHref" index="officeRoleForHref">办公区服务配置</el-menu-item>
            </el-submenu>
            <el-submenu index="4" v-if="routeJur.OfficeCar">
              <template slot="title">车辆管理</template>
              <el-menu-item class="ellipsis" index="officeCar">车辆信息管理</el-menu-item>
              <el-menu-item class="ellipsis" index="officeCarHistory">车辆申请记录</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="20">
        <transition name="el-zoom-in-to" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OfficeNew",
  components: {},
  data() {
    return {
      activeIndex: ""
    };
  },
  computed: {
    ...mapState(["routeJur"])
  },
  created() {},
  mounted() {
    this.initIndex();
  },
  methods: {
    initIndex() {
      this.activeIndex = this.$route.name;
    },
    goPage(index) {
      // console.log(index);
      this.$router.push({
        name: index
      });
    }
  },
  watch: {
    $route() {
      this.initIndex();
    }
  }
};
</script>

<style scoped>
.about-nav-bar {
  min-height: 650px;
}
</style>
